export default __webpack_public_path__ + "static/media/whyHyper.cd052bb7.svg";